import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=39432f99&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\immersive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39432f99')) {
      api.createRecord('39432f99', component.options)
    } else {
      api.reload('39432f99', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=39432f99&", function () {
      api.rerender('39432f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spinner.vue"
export default component.exports